<style lang="scss" scoped>
  .developers-page {
    position: relative;
    font-family: 'VK Sans Display', Arial, 'Helvetica Neue', Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;

    .content {
      &.below-viewport {
        transition: all .4s linear 0s;
        transform: translateY(50px);
        opacity: 0;
      }

      &.in-viewport {
        transition: all .4s linear 0s;
        transform: translateY(0px);
        opacity: 1;
      }

      &.above-viewport {
        transition: none;
        transform: none;
        opacity: 1;
      }
    }

    .features {
      position: relative;
      margin-bottom: 130px;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 788px;
        background: cdn('images/b2b/page-bg.png') no-repeat center;
        background-size: auto 100%;
      }

      @include media(max, lg) {
        margin-bottom: 50px;
      }
    }

    .services {
      position: relative;
      z-index: 2;

      &:before {
        content: '';
        position: absolute;
        top: 214px;
        left: 0;
        right: 0;
        height: 788px;
        background: cdn('images/b2b/page-bg.png') no-repeat center;
        background-size: auto 100%;
      }
    }

    .footer {
      position: relative;
      z-index: 2;
      color: #fff;
      background: #006de7;
      border-radius: 80px 80px 0 0;

      @include media(max, lg) {
        border-radius: 20px 20px 0 0;
      }
    }

    .tools {
      position: relative;
      z-index: 1;
      margin-bottom: 100px;
      padding: 296px 0 100px;
      width: 100%;
      color: #000;
      background: #fff;
      border-radius: 80px;

      @include media(max, lg) {
        padding: 256px 0 50px;
        margin-bottom: 50px;
        border-radius: 0 0 20px 20px;
      }
    }

    .dev-pc {
      position: relative;
      z-index: 2;
    }
  }

</style>

<template>
  <main-layout>
    <div
      class="developers-page"
    >
      <section class="header">
        <Header/>
      </section>
      <section class="features">
        <Features/>
      </section>
      <section class="dev-pc">
        <div class="content" v-in-viewport>
          <DevPc/>
        </div>
      </section>
      <section class="tools">
        <div class="content" v-in-viewport>
          <Tools/>
        </div>
      </section>
      <section class="services">
        <div class="content" v-in-viewport>
          <Services/>
        </div>
      </section>
      <section class="footer">
        <div class="content js-footer-content" v-in-viewport>
          <Footer/>
        </div>
      </section>
    </div>
  </main-layout>
</template>

<script>

import Header from '@components/DevelopersComponents/Header.vue';
import Features from '@components/DevelopersComponents/Features.vue';
import DevPc from '@components/DevelopersComponents/DevPc.vue';
import Tools from '@components/DevelopersComponents/Tools.vue';
import Services from '@components/DevelopersComponents/Services.vue';
import Footer from '@components/DevelopersComponents/Footer.vue';

import { getFavicons } from '@utils/helpers';

export default {
  name: 'Developers',
  components: {
    Header,
    Features,
    DevPc,
    Tools,
    Services,
    Footer,
  },
  page() {
    const pageTitle = this.getCurrentLang === 'ru' ? 'Кабинет разработчика' : 'Developer Dashboard';
    const pageTitleHost = 'VK Play';

    return {
      title: 'Developers',
      titleTemplate: `${pageTitle} | ${pageTitleHost}`,
      meta: [
        {
          name: 'description',
          content: this.getCurrentLang === 'ru' ? 'Портал для разработчиков.' : 'Developer Dashboard.',
        },
      ],
      link: [
        ...getFavicons(),
      ],
    };
  },
  data() {
    return {
      welcome: false,
    };
  },
};

</script>
